<template>
  <v-card
    class="mx-3 mb-5"
    max-width="300"
    dark
  >
    <v-img
        class="white--text align-end"
        height="200px"
        src="https://media0.giphy.com/media/xThuWdFWwPo95aieJO/giphy.gif?cid=ecf05e474pqnfanq6lm8frxt004fp1skaace3i74xqnmwd9g&rid=giphy.gif&ct=g" 
      >
        <v-card-title text="purple lighten-3">Discord Bot</v-card-title>
    </v-img>

    <v-card-text>
        <div>BUILT WITH.</div>
        <div div>JavaScript</div>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="purple lighten-3"
        text
        href="https://github.com/rogieBeer/TurtleBot"
      >
        CODE
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
    name: "ProjectCard4"

}
</script>

<style scoped>

</style>